import { ThemeToggle } from '@/theme/ThemeToggle';
import { Plus, Search, LogOut, Menu } from 'lucide-react';
import { useAuth } from '@/auth/useAuth';

interface HeaderProps {
  onSearchClick: () => void;
  onNewClick: () => void;
  onMenuClick: () => void;
}

export function Header({ onSearchClick, onNewClick, onMenuClick }: HeaderProps) {
  const { state, logout } = useAuth();
  return (
    <header className="flex items-center justify-between border-b border-border/70 px-4 py-2.5">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Abrir menu"
          className="-ml-1 inline-flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground md:hidden"
        >
          <Menu className="h-5 w-5" strokeWidth={2} />
        </button>
        <div className="h-5 w-5 rounded-sm bg-primary" />
        <span className="text-sm font-semibold tracking-tight">CRM Prospect</span>
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          aria-label="Buscar (⌘K)"
          title="Buscar (⌘K)"
          onClick={onSearchClick}
          className="inline-flex h-8 items-center gap-2 rounded-md border border-border/70 bg-background px-2.5 text-xs text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        >
          <Search className="h-3.5 w-3.5" strokeWidth={2} />
          <span className="hidden sm:inline">buscar</span>
          <kbd className="mono hidden sm:inline-flex items-center rounded border border-border/70 px-1 text-[10px]">⌘K</kbd>
        </button>
        <button
          type="button"
          aria-label="Nova empresa (⌘N)"
          title="Nova empresa (⌘N)"
          onClick={onNewClick}
          className="inline-flex h-8 items-center gap-1.5 rounded-md bg-primary px-2.5 text-xs font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />
          nova empresa
        </button>
        <div className="mx-1 h-5 w-px bg-border" />
        <ThemeToggle />
        <button
          type="button"
          onClick={logout}
          className="inline-flex h-8 items-center gap-1.5 rounded-md px-2.5 text-xs text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          title="Sair"
        >
          <span className="hidden sm:inline">{state.email}</span>
          <LogOut className="h-3.5 w-3.5" strokeWidth={2} />
        </button>
      </div>
    </header>
  );
}
